import { render, staticRenderFns } from "./SisProgrammeBreak.vue?vue&type=template&id=92f00120&"
import script from "./SisProgrammeBreak.vue?vue&type=script&lang=ts&"
export * from "./SisProgrammeBreak.vue?vue&type=script&lang=ts&"
import style0 from "./SisProgrammeBreak.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports